import React from 'react';
import { Link } from 'react-router-dom';
import styles from './styles/MyClassroomsGridItem.module.css';

const MyClassroomsGridItem = ({
    classroom,
    classroomImages,
    index,
    openedDropdown,
    setOpenedDropdown,
    openEditModal,
    isOwnedClassroom,
}) => {
    return (
        <Link to={`/my-classrooms/${classroom._id}/d`} className={styles.gridItemLink}>
            <div className={`${styles.classroomItem} ${isOwnedClassroom ? styles.ownedClassroom : styles.joinedClassroom}`}>
                <img
                    className={styles.classroomImage}
                    src={classroom.image || classroomImages[index % classroomImages.length]}
                    alt={`${classroom.name} cover`}
                />
                <div className={styles.classroomInfo}>
                    <div className={styles.classroomName}>{classroom.name}</div>
                </div>
                {isOwnedClassroom && (
                    <button
                        className={styles.optionsButton}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setOpenedDropdown(classroom._id === openedDropdown ? null : classroom._id);
                        }}
                        aria-label="Classroom options"
                    >
                        <span className={styles.optionsIcon}>⋮</span>
                    </button>
                )}
                {openedDropdown === classroom._id && (
                    <div
                        className={styles.optionsDropdown}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className={styles.optionsDropdownItem} onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            openEditModal(classroom);
                            setOpenedDropdown(null);
                        }}>
                            Edit
                        </div>
                    </div>
                )}
            </div>
        </Link>
    );
};

export default MyClassroomsGridItem;
